import { AnyAction, Reducer } from "redux";
import { IFilter, IFilterValue } from "src/types/filter";
import { ISort } from "src/types/sort";

import { actionTypes } from "./actions";

export interface ICategoryState {
  availableFilters: IFilter[];
  availableSorts: ISort[];
  filters: IFilterValue[];
  sort?: ISort;
}

export const initialState: ICategoryState = {
  availableFilters: [],
  availableSorts: [],
  filters: [],
  sort: undefined,
};

const categoryReducer: Reducer<ICategoryState> = (
  state: ICategoryState = initialState,
  { type, payload }: AnyAction
): ICategoryState => {
  switch (type) {
    case actionTypes.CATEGORY_SET_AVAILABLE_FILTERS:
      return {
        ...state,
        availableFilters: payload.availableFilters,
      };

    case actionTypes.CATEGORY_SET_AVAILABLE_SORTS:
      return {
        ...state,
        availableSorts: payload.availableSorts,
      };

    case actionTypes.CATEGORY_SET_FILTERS:
      return {
        ...state,
        filters: payload.filters,
      };

    case actionTypes.CATEGORY_SET_SORT:
      return {
        ...state,
        sort: payload.sort,
      };

    default:
      return state;
  }
};

export default categoryReducer;
